<p-tabView
  [activeIndex]="activeTabIndex()"
  (activeIndexChange)="activeTabIndex.set($event)"
  [ngClass]="'communications'"
>
  <ng-container *ngFor="let chat of visibleChats()">
    <p-tabPanel>
      <ng-template pTemplate="header">
          <span [ngClass]="chat.commentsCount > 0 ? 'bold-tab' : ''">
            {{ titleMap[chat.chatType] }}
          </span>
      </ng-template>
      <tj-ticket-comments
        [chatId]="chat.id"
        [chatType]="chat.chatType"
        [technicians]="technicians"
      ></tj-ticket-comments>
    </p-tabPanel>
  </ng-container>
</p-tabView>
